export const _feedback_slideshow = [
    {
        alt: "Eterna",
        quote:
            "„Das Eterna Regal besticht durch sein minimalistisches, modernes Design. Die klare Linienführung und die edle schwarze Oberfläche machen es zu einer stilvollen Ergänzung für jedes Wohn- oder Arbeitszimmer.“",
        product: "Eterna",
    },
    {
        alt: "Luce",
        quote:
            "„Das Luce Regal bietet eine elegante Kombination aus Funktionalität und Ästhetik. Die doppelte Ablagefläche sorgt für mehr Stauraum und verleiht dem Raum eine moderne Note.“",
        product: "Luce",
    },
    {
        alt: "Senso",
        quote:
            "„Das Senso Regal ist perfekt für alle, die ein kreatives und praktisches Möbelstück suchen. Die unterschiedlichen Höhen der Ablagen ermöglichen vielseitige Einsatzmöglichkeiten.“",
        product: "Senso",
    },
    {
        alt: "Weinhalter",
        quote:
            "„Dieser elegante Weinhalter setzt Flaschen stilvoll in Szene. Die hochwertige Verarbeitung macht ihn zu einer idealen Geschenkidee für Weinliebhaber.“",
        product: "Bow Chair – Weinhalter",
    },
    {
        alt: "Schachbrett-Set",
        quote:
            "„Ein wunderschön gestaltetes Schachbrett mit modernem Touch. Die edle Materialwahl macht es zu einem echten Hingucker.“",
        product: "Bow Chair – Schachbrett-Set",
    },
    {
        alt: "Kleiderbügel-Set",
        quote:
            "„Schlicht, elegant und funktional. Diese Kleiderbügel bieten eine moderne Optik und eignen sich perfekt für stilbewusste Kunden.“",
        product: "Bow Chair – Kleiderbügel-Set",
    },
    {
        alt: "Tic-Tac-Toe-Set",
        quote:
            "„Eine kreative und dekorative Spielidee. Die edlen Materialien machen es zu einem stilvollen Geschenk oder Wohnaccessoire.“",
        product: "Bow Chair – Tic-Tac-Toe-Set",
    },
];